import * as i from 'types';

export const calculateFleetValues = (object: i.FleetInput) => {
  return Object.values(object)
    .reduce((accumulator, value) => accumulator + value, 0);
};
